var map = {
	"./uclg/Bebas-Regular.otf": 88788,
	"./uclg/Bebas-Regular.ttf": 43975,
	"./uclg/itc-officina-sans-std-bold.ttf": 19609,
	"./uclg/itc-officina-sans-std-bold.woff": 41279,
	"./uclg/itc-officina-sans-std-bold.woff2": 28879,
	"./uclg/itc-officina-sans-std-book.ttf": 91359,
	"./uclg/itc-officina-sans-std-book.woff": 28589,
	"./uclg/itc-officina-sans-std-book.woff2": 6837
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 51549;